import { schema as schemas } from 'normalizr'
import qs from 'qs'
import { CallApi } from '@signavio/kraken'

import { schema as groupSchema } from './group'

export { collection } from './group'

export const schema = new schemas.Array(groupSchema)

const defaultRequestParams = {
  offset: 0,
  pagesize: 9999,
}

type GroupRequestParamsT = {
  offset: number
  pagesize: number
}

type GroupQueryT = {
  name?: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ name }: GroupQueryT, _: unknown, requestParams: GroupRequestParamsT) =>
    callApi(
      `${apiBase}/groups${qs.stringify(
        { ...defaultRequestParams, name, ...requestParams },
        {
          addQueryPrefix: true,
        }
      )}`,
      schema
    )
